import React from "react";
import { cn } from "../cn";

export type IGrid2Props = {
  children: React.ReactNode;
  className?: string;
  innerContainerClassName?: string;
  style?: React.CSSProperties;
}

export const Grid2 = (props: IGrid2Props) => {
  return <div className={cn(
    'px-5 py-8 md:px-10 lg:px-20 xl:px-[120px]',
    props.className,
  )} style={props.style}>
    <div className={cn('max-w-[1200px] m-auto', props.innerContainerClassName)}>
      {props.children}
    </div>
  </div>
}